export const ENV = [
    { host: 'localhost', env: 'local' },
    {host:'swimlions.cn',env:'test'},
    {host:'.cn',env:'prod'},
].find(e => location.host.indexOf(e.host) >= 0).env

export const API_BASE = {
    // local: 'http://localhost:7001/api',
    // local:'http://47.52.43.212:7001/api',
    local:'https://essayd.swimlions.cn/api',
    prod:'/api',
}[ENV]


export const USER_SOURCE = {
    1:'微博/微信',
    2:'百度/谷歌',
    3:'留学论坛',
    4:'知乎推荐',
    5:'好友推荐',
    6:'线下了解',
    7:'其他渠道',

    8:'好友推荐',
    9:'微信公众号',
    10:'小红书推荐',
    11:'微博推荐',
}

// 数据库存的是数字，所以只好用新增枚举 + display source 的方法了
export const DISPLAY_SOURCE = [8,3,2,9,4,10,11,6,7]

export const ORDER_TYPE_MAP = {
    1: '高级润色',
    2:'原创定制'
}

export const ORDER_STATUS = {
    10:'已取消',
    100:'待支付',
    200: '待确认',
    400: '待上传资料',
    401: '上传资料超时',
    500: '资料审核中',
    405: '资料审核失败',
    510: '资料审核成功',
    550: '材料翻译中',
    600: '文书创作中',
    700: '文书校验中',
    800: '已发送',
    900: '服务反馈',
    1000: '已完成'
}

export const ORDER_STATUS_DESC = {
    10:'订单已取消',
    100:'订单待支付',

    200:'订单已提交，正等待确认',
    400: '订单已确认，请将相关文书资料合并在一个压缩包内，共同上传',
    401: '上传资料超时，请重新选择交稿时间',
    500: '您的资料已收到，正排队等待审核',
    405: '资料审核未通过，请更新后重新上传',
    510: '资料审核成功，将立即开始创作',
    550: '材料翻译中',
    600: '文书已开始创作，请耐心等待，并留意您的邮箱',
    700: '文书已创作完成，正交由审核团队最终校验',
    800: '文书成稿已发送至您的邮箱，请及时查阅',
    900:'',
    1000:'您的订单已完成'
}

export const EDU_BG_MAP = {
    100:'初中以下',
    200:'高中',
    // 300:'大专',
    400:'本科',
    500:'硕士研究生',
    600:'博士研究生'
}